import React from "react";
import "./PosDashboard.scss";

/**
 * Single chart-card placeholder (matches `.pos-dashboard-chart-skeleton__*` in PosDashboard.scss).
 */
export default function DashboardChartCardSkeleton() {
  return (
    <article
      className="pos-dashboard-chart-skeleton__card"
      aria-busy="true"
      aria-label="Loading chart"
    >
      <div className="pos-dashboard-chart-skeleton__head">
        <span className="pos-dashboard-skeleton-line pos-dashboard-chart-skeleton__title" />
        <span className="pos-dashboard-skeleton-line pos-dashboard-chart-skeleton__menu" />
      </div>
      <span className="pos-dashboard-skeleton-line pos-dashboard-chart-skeleton__plot" />
      <span className="pos-dashboard-skeleton-line pos-dashboard-chart-skeleton__legend" />
    </article>
  );
}
